import PackagingCertificationService from 'src/modules/packagingCertification/packagingCertificationService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PACKAGINGCERTIFICATION_FORM';

const packagingCertificationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: packagingCertificationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PackagingCertificationService.find(id);
      }

      dispatch({
        type: packagingCertificationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: packagingCertificationFormActions.INIT_ERROR,
      });

      navigateTo('/library/packaging-certification');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: packagingCertificationFormActions.CREATE_STARTED,
      });

      await PackagingCertificationService.create(values);

      dispatch({
        type: packagingCertificationFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.packagingCertification.create.success'));

      navigateTo('/library/packaging-certification');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: packagingCertificationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: packagingCertificationFormActions.UPDATE_STARTED,
      });

      await PackagingCertificationService.update(id, values);

      dispatch({
        type: packagingCertificationFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.packagingCertification.update.success'));

      navigateTo('/library/packaging-certification');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: packagingCertificationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default packagingCertificationFormActions;
